import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import { Link, useNavigate } from "react-router-dom";
import PageTitle from "../../../components/partials/PageTitle";
import pdf from "../../../assets/images/img-icons/pdf.png";
import excel from "../../../assets/images/img-icons/excel.png";
import PaginationLinks from "../../../components/pagination/PaginationLinks";
import { useSelector } from "react-redux";
import moment from "moment";
import { MdRemoveRedEye } from "react-icons/md";
import {
  getAllClaimSettings,
  resetSingleClaim,
} from "../../../redux/slice/claim/claimSlice";
import { useDispatch } from "react-redux";
import { resetSinglePolicyCover } from "../../../redux/slice/policy/policySlice";
import { getAllCovers } from "../../../redux/slice/cover/coverSlice";
import { LoaderTwo } from "./../../../components/loader/LoaderTwo";

const ClaimConfiguration = () => {
  const CCPdfRef = useRef();
  const { claim_settings } = useSelector((state) => state?.claim);
  const { user_permissions } = useSelector((state) => state?.auth?.user);
  const { all_covers } = useSelector((state) => state?.cover);

  const [hasCreateClaim, setHasCreateClaim] = useState(null);
  const [hasViewClaim, setHasViewClaim] = useState(null);
  const [filterBy, setFilterBy] = useState('');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const breadcrumb = {
    from: {
      title: "Claim Configuration",
      link: "/admin/settings/claim-configuration",
    },
    current: {
      title: "List",
      link: null,
    },
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (filterBy?.length) {
      const payload = {
        search: filterBy,
        pageNum: 1
      };
      dispatch(getAllClaimSettings(payload));
    }
};

  const fetchClaimsHandler = async (pageNum) => {
    // setPageNumber(pageNum);
    dispatch(getAllClaimSettings({pageNum, search: filterBy}));
  };

  useEffect(() => {
    if (!all_covers?.length) {
      dispatch(getAllCovers());
    }
    if (!filterBy)  {
      dispatch(getAllClaimSettings({pageNum: 1, search: ''}));
    }
    dispatch(resetSinglePolicyCover());
    dispatch(resetSingleClaim());
  }, [dispatch, filterBy]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "claim configuration module"
      )
    ) {
      navigate("/admin/dashboard");
    }

    setHasCreateClaim(
      user_permissions?.some(
        (permission) => permission.name === "create claim configuration"
      )
    );
    setHasViewClaim(
      user_permissions?.some(
        (permission) => permission.name === "view claim configuration"
      )
    );
  }, [navigate, user_permissions]);

  if (claim_settings?.length === 0) {
    return (
      <div className='mt-3'>
        <LoaderTwo />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Claim Configuration' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row card p-1' style={{ margin: "auto 1px" }}>
        <div className='mb-1 pb-1 border border-bottom-1 border-start-0 border-end-0 border-top-0'>
          <div className={`d-flex justify-content-between align-items-center`}>
            <div>
              {hasCreateClaim && (
                <Link
                  className='d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary cursor-p px-3'
                  style={{ height: "30px", padding: "10px 10px" }}
                  to='/admin/settings/claim-configuration/add'
                >
                  <span>
                    <i className='mdi mdi-plus fs-4'></i>
                  </span>
                  <span className='text-dark pe-2 text-white'>
                    Add Configuration
                  </span>
                </Link>
              )}
            </div>
            <div className='d-flex justify-content-between align-items-center gap-3'>
              <form
                  onSubmit={handleSearch}
                className='d-flex bg-primary-1 align-items-center '
                style={{ height: "30px", width: "217px" }}
              >
                <input
                  type='search'
                  value={filterBy}
                  className='border-0'
                  placeholder='Search...'
                  onChange={(e) => setFilterBy(e.target.value)}
                  style={{ height: "28px", marginLeft: "1px", outline: "none" }}
                />
                <button
                  type='submit'
                  className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                  style={{ height: "28px" }}
                >
                  <i className='uil uil-search text-white fs-4'></i>
                </button>
              </form>
              <div className=' d-flex align-items-center border '>
                <span
                  className='bg-info me-2 text-white'
                  style={{ padding: "3px" }}
                >
                  Export to
                </span>
                <span
                  href='#'
                  id='btnExport'
                  className='me-1'
                  title='Export to Pdf'
                  // onClick={generatePDF}
                >
                  <img src={pdf} alt='export-pdf' style={{ height: "20px" }} />
                </span>
                <CSVLink
                  data={[]}
                  style={{ fontWeight: "bolder" }}
                  filename='Available Users'
                >
                  <span
                    href='#'
                    id='btnExport'
                    className='mr-1'
                    title='Export to Excel'
                  >
                    <img
                      src={excel}
                      alt='export-excel'
                      style={{ height: "20px", marginRight: "5px" }}
                    />
                  </span>
                </CSVLink>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12'>
          <div className='position-relative'>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='table-responsive'>
                  <table
                    className='table table-centered table-striped nowrap w-100 no-footer'
                    ref={CCPdfRef}
                  >
                    <thead>
                      <tr>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "225.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Name
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy Name
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy Cover
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                          aria-label='Email: activate to sort column ascending'
                        >
                          Date
                        </th>
                        {hasViewClaim && (
                          <th
                            className='sorting text-center'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "165.8px" }}
                            aria-label='Status: activate to sort column ascending'
                          >
                            Action
                          </th>
                        )}
                      </tr>
                    </thead>
                    {claim_settings?.data?.length ? (
                      <tbody>
                        {claim_settings?.data?.map((item, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <span>{item.settings_name}</span>
                              </td>
                              <td>{item.policy_name}</td>
                              <td>
                                {
                                  all_covers?.unpaginated_cover?.filter(
                                    (cover) =>
                                      String(item.policy_cover) ===
                                      String(cover.id)
                                  )[0]?.name
                                }
                              </td>
                              <td className=''>
                                {moment(`${item?.created_at}`).format("LL")}
                              </td>
                              {hasViewClaim && (
                                <td className='text-center'>
                                  <Link
                                    to={`/admin/settings/claim-configuration/${item?.id}`}
                                    className='text-left'
                                  >
                                    <MdRemoveRedEye
                                      className='text-primary'
                                      style={{
                                        fontSize: "20px",
                                        textAlign: "start",
                                      }}
                                    />
                                  </Link>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : null}
                  </table>
                </div>
                {!claim_settings?.data?.length ? (
                  <h5 className='alert alert-info'>No result found!</h5>
                ) : null}
                {claim_settings?.data?.length > 0 && (
                  <div className='row mt-2'>
                    <div className='col-sm-12 col-md-6'>
                      <div
                        className='dataTables_info table-pages'
                        id='products-datatable_info'
                        role='status'
                        aria-live='polite'
                      >
                        Showing offices {claim_settings?.from} to{" "}
                        {claim_settings?.to} of {claim_settings?.total}
                      </div>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                      <PaginationLinks
                        paginationData={claim_settings}
                        getNextPage={fetchClaimsHandler}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClaimConfiguration;
